import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron",
  "use": "icon-chevron-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 8\" id=\"icon-chevron\"><g clip-path=\"url(#icon-chevron_a)\"><path d=\"m.88 7 5-5 5 5\" stroke=\"#242526\" stroke-width=\"2\" /></g><defs><clipPath id=\"icon-chevron_a\"><path fill=\"#fff\" transform=\"translate(.332)\" d=\"M0 0h15.668v8H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol